<template>
    <div>
        <h2 v-html="task.question" />
        <div class="row">
            <div class="col-12 p-4">
                <b>Eredeti tartalom:</b>
                <p v-html="originalText" />
            </div>
        </div>
        <div class="row">
            <div class="col-12 p-4">
                <b>Az Ön által megadott eredmény:</b>
                <p v-html="userSolution"></p>
            </div>
        </div>
    </div>
</template>
<script>
import {each} from "lodash";

export default {
    props: {
        userTask: {
            type: Object,
            required: true,
        },
        task: {
            type: Object,
            required: true,
        },
    },
    computed: {
        originalText() {
            return this.task.taskable.content.replaceAll('{{', '').replaceAll('}}', '');
        },
        userSolution() {
            let content = this.task.taskable.content;
            each(this.userTask.solution.selected_words, (word) => {
                if (word === null) {
                    content = content.replace(/{{(.+?)}}/i, '..........................');
                    return;
                }

                content = content.replace(/{{(.+?)}}/i, word.value);
            });
            return content;
        }
    }
}
</script>
